<template>
  <div class="container create-event">
    <div class="row mb-45">
      <div class="col-12">
        <h1>Request Wellbeing Workshop</h1>
      </div>

    </div>
    <div class="row">
      <div class="col-12">
        <div class="dashboard-card event-card">
          <label class="upper">WORKSHOP DETAILS</label>
          <form-component>
            <form novalidate="novalidate" @submit.prevent="doSave">
              <div class="form-row"
                v-if="$store.getters.currentUser.isAdmin || $store.getters.currentUser.isCollegeAdmin">
                <div class="col-12">
                  <input-type-ahead :list="users" :value="user" :searchchange="getUsers" :selected-value="selectedUser"
                    placeholder="Search for a User..." label="Host" option-value="id" option-text="display_label" />
                </div>
              </div>

              <div class="form-row">
                <div class="col-12 col-lg-8">
                  <input-text id="topic" v-model="topic" v-validate="'required'" name="topic" data-vv-name="topic"
                    data-vv-as="topic" label="Topic" type="text" required :error="errors.first('topic')" />
                </div>
                <div class="col-lg-4  col-12">
                  <input-text id="user_limit" v-model="user_limit" name="user_limit" label="Maximum Attendees"
                    type="number" data-vv-name="user_limit" data-vv-as="Maximum Attendees" v-validate="'required'" :error="errors.first('user_limit')" required/>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 ">
                  <input-text-area id="description" v-model="description" v-validate="'required'" name="description"
                    data-vv-name="description" data-vv-as="description" label="Description" type="text" required
                    :error="errors.first('description')" />
                </div>
              </div>
              <div class="form-row">
                  <div class="col-12 col-lg-4">
                    <label :class="fileError ? 'replacement-label file-upload-error'  : 'replacement-label '">Upload Presentation</label>
                    <div class="custom-file-container">
                    <b-form-file
                      id="fileUpload"
                      v-model="fileUpload"
                      name="fileUpload"
                      accept="image/*,application/pdf,application/msword,application/vnd.ms-powerpoint"
                      placeholder="Select a PPT, PDF, DOC, or DOCX file"
                      drop-placeholder="Drop file here..."
                      :state="Boolean(fileUpload)"
                      required
                    />
                    <font-awesome-icon
                      :icon="['fas', 'file-upload']"
                      class="icon alt"
                    />
                  </div>
                  <p v-show="fileError" class="file-upload-error">
                    Document upload is required
                  </p>
                </div>
                </div>
              <div class="form-row">
                <div class="col-12">
                  <label class="replacement-label">RELATED TOPICS/CATEGORIES</label>
                  <vue-tags-input v-model="specialty" placeholder="Select Topics" :add-only-from-autocomplete="true"
                    :autocomplete-items="filteredSpecialties" :autocomplete-min-length="0" :tags="specialty_ids"
                    @tags-changed="newTags => specialty_ids = newTags" />
                </div>
              </div>
            </form>
          </form-component>
          <div class="form-row py-4 mx-0 justify-content-center date-picker-row">
            <div id="cronofy-date-time-picker"></div>
          </div>
          <div class="form-row">
            <div class="col-lg-4 col-12">
              <button type="button" @click="doSave()" class="btn btn-primary btn-block w-100">
                <font-awesome-icon v-if="saving" :spin="true" :icon="['fas', 'spinner']" class="icon alt" />
                <span v-else>Request Workshop</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import InputSingleDateTimeRangePicker from '@/components/inputs/InputSingleDateTimeRangePicker.vue';
import CounselorClient from '@/api/CounselorClient';
import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';
import moment from 'moment';

export default {
  name: 'CreateWorkshop',
  components: {
    FormComponent,
    InputText,
    InputSelect,
    InputTypeAhead,
    InputTextArea,
    VueTagsInput,
    InputSingleDateTimeRangePicker,
  },
  data() {
    return {
      saving: false,
      counselorClient: new CounselorClient(this.$http),
      userClient: new UserClient(this.$http),
      adminClient: new AdminClient(this.$http),

      topic: '',
      user_limit: '',

      description: '',

      specialty: '',
      specialty_ids: [],
      all_specialties: [],

      users: [], // { id, name, state_code }
      _getUsersTimeout: null,
      user: null,
      availabilityToken: null,
      dateTimeSlot: null,
      fileUpload: null,
      fileError:false


    };
  },
  computed: {
    filteredSpecialties() {
      return this.all_specialties.filter(i => {
        return i.text.toLowerCase().indexOf(this.specialty.toLowerCase()) !== -1;
      }).map(r => {
        return {
          id: r.id,
          text: r.text,
        };
      });
    },
  },
  async mounted() {
    const all_specialties = await this.userClient.getSpecialtiesList('', 500);
    this.all_specialties = all_specialties.results || [];
    if (this.$store.getters.currentUser.hasInitializedCal) {
      this.counselorClient.getAvailabilityToken(this.$store.getters.currentUser.counselor_profile.id).then(response => {
        const data = {
          element_token: response.token.token,
          target_id: "cronofy-date-time-picker",
          availability_query: {
            participants: [
              {
                required: "all",
                members: response.token.subjects.map(subject => ({
                  sub: subject,
                  managed_availability: true,
                }))
              }
            ],
            required_duration: { minutes: 60 },
            query_periods: [
              {
                start: moment().startOf('minute').toISOString(),
                end: moment().startOf('minute').add(160, 'days').toISOString()
              }
            ]
          },
          config: {
            mode: 'no_confirm'
          },
          styles: {
            colors: {
              button: "#f5f5f5",
              buttonActive: "#0f2a45",
              buttonActiveText: "#f5f5f5",
              buttonHover: "#224b73",
              buttonTextHover: "#f5f5f5"
            },
            prefix: "date-time-picker"
          },
          callback: notification => {
            if (!notification || !notification.notification)
              return

            const type = notification.notification.type
            if (type === 'error')
              console.error(notification.notification)

            else if (type === 'warn')
              console.warn(notification.notification)

            if (type === 'slot_selected')
              this.dateTimeSlot = notification.notification.slot
          }
        };
        window.CronofyElements.DateTimePicker(data);
      });
    }
  },
  methods: {
    getUsers(query, done) {
      if (this.user && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getUsersTimeout) {
        clearTimeout(this._getUsersTimeout);
        this._getUsersTimeout = null;
      }

      this._getUsersTimeout = setTimeout(() => {

        if (this.$store.getters.currentUser.isAdmin) {
          this.adminClient.getAllUserList(query, 10, 0, true).then((users) => {
            this.user = null;
            this.users = users.results || [];
          }).catch(() => {
            this.user = null;
            this.users = [];
          });
        } else {
          this.adminClient.getMyCollegeUserList(query).then((users) => {
            this.user = null;
            this.users = users.results || [];
          }).catch(() => {
            this.user = null;
            this.users = [];
          });
        }
      }, 300);
    },
    selectedUser(v) {
      this.user = v;
    },

    async doSave() {
      const valid = await this.$validator.validateAll();
      if(this.fileUpload == null){
        this.fileError = true;
        return;
      }

      this.fileError = false;

      if (!valid || !this.dateTimeSlot)
        return;

      this.saving = true;
      const user_limit = parseInt(this.user_limit, 0) || 0;
      const data = {
        counselorId: this.$store.getters.currentUser.counselor_profile.id,
        topic: this.topic,
        userLimit: user_limit,
        startTime: this.dateTimeSlot.start,
        endTime: this.dateTimeSlot.end,
        struggleAreaIds: this.specialty_ids.map(s => s.id),
        description: this.description,
        file: { contentType: this.fileUpload.type }
      };

      if (this.user) {
        data.host = this.user;
      }

      try {
        const response = await this.counselorClient.requestNewWorkshop(data);
        
        await UserClient.saveFileWithContentType(
          response.workshopFile.setUrl, 
          this.fileUpload);
        this.saving = false;
        this.$router.push({ name: 'counselor-workshops', params: { from: 'new-workshop' } });


      } catch (ex) {
        this.saving = false;
        let errorMessage = 'Failed to add workshop. Please try again!';

        if (ex && ex.body && ex.body.error && ex.body.error.extra && ex.body.error.extra.detail) {
          errorMessage = ex.body.error.extra.detail;
        } else if (ex && ex.body && ex.body.error && ex.body.error.message) {
          errorMessage = ex.body.error.message;
        }

        this.$store.commit('setGlobalAlert', {
          msg: errorMessage, 
          error: true,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.create-event {
  label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }

  .event-sidebar {
    h2 {
      @media (min-width: $xl-min) {
        font-size: 22px;
        margin-top: 6px;
      }
    }

    .pills {
      text-align: right;

      @media (max-width: $lg-max) {
        text-align: left;
      }

      li {
        white-space: nowrap;
      }
    }
  }

  .attending {
    label {
      @include label;

      display: block;
      margin-bottom: 10px;
    }

    .text-btn {
      @include label;

      border: none;
      background: none;
      color: $green;
      padding: 0;
      outline: none;
      height: auto;
      font-weight: normal;
      text-align: right;
      text-transform: none;
      opacity: 0.5;

      &:hover,
      &:focus {
        opacity: 1;
        text-decoration: underline;
      }
    }
  }

  .avatars {
    display: inline-block;
    margin-top: 10px;
    margin-left: -5px;
    margin-bottom: -5px;

    .user-avatar {
      @include background-cover;
      @include border-radius(100px);

      background-image: url('~@/assets/img/default-user.jpg');
      display: inline-block;
      height: 50px;
      width: 50px;
      margin: 5px;
    }
  }

  .event-settings {
    label {
      @include label;

      color: $green;
      margin-bottom: 15px;
    }
  }

  .delete-btn {
    width: 100%;

    i,
    svg {
      margin-right: 5px;
    }

    &:hover,
    &:focus {
      background: $red;
      color: white;
      border-color: $red;
    }
  }
}  

.file-upload-error {
  color: #ff6e3d;
}

</style>
